<template>
  <div
    class="container v-content-container tooltip-wrapper"
    :key="componentKey"
  >
    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-fw fa-lg fa-list-alt"></i>
          <span>
            {{ selectedEvent == null ? "Event" : selectedEvent.name }}
          </span>
        </h1>
      </div>
    </div>

    <navigation-tabs :event-id="selectedEventId"></navigation-tabs>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <div class="row mb-2">
        <div class="col-sm-3 col-xs-6" style="display: flex;">
          <select class="pagination-select" id="per-page" v-model="perPage">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </select>
        </div>
        <div class="col-sm-3 col-xs-6">
          <div>
            <input
              type="text"
              aria-controls="table-categories"
              class="form-control input-small"
              v-tooltip="{
                content: $label('event.appointment_name', 'Appointment name'),
                classes: 'custom-tooltip'
              }"
              v-model="searchFilter"
              :placeholder="$label('event.search_placeholder', 'Search ...')"
            />
          </div>
        </div>
        <div
          v-show="
            eventAppointmentsLength > 0 &&
              eventAppointmentsLength != null &&
              !failedRequest
          "
          class="col-sm-6 col-xs-12 hidden-xs"
        >
          <div
            class="dataTables_paginate paging_bootstrap_full_number"
            style="text-align: right;"
          >
            <ul class="pagination mt-0" style="visibility: visible;">
              <li class="prev" :class="{ disabled: disabledFirstPage }">
                <a
                  @click="goToFirstPage"
                  v-tooltip="{
                    content: $label('common.first_page', 'First page'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-double-left"></i
                ></a>
              </li>
              <li class="prev" :class="{ disabled: disabledPreviousPage }">
                <a
                  @click="goToPreviousPage"
                  v-tooltip="{
                    content: $label('common.back'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-left"></i
                ></a>
              </li>
              <li class="active">
                <a>{{ currentPage }}</a>
              </li>
              <li class="next" :class="{ disabled: disabledNextPage }">
                <a
                  @click="goToNextPage"
                  v-tooltip="{
                    content: $label('common.next', 'Next'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-right"></i
                ></a>
              </li>
              <li class="next" :class="{ disabled: disabledLastPage }">
                <a
                  @click="goToLastPage"
                  v-tooltip="{
                    content: $label('common.last_page', 'Last page'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-double-right"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row mt-8">
        <div class="col-xs-12">&nbsp;</div>
      </div>

      <alert-box
        v-show="eventAppointmentsLength < 1 && eventAppointmentsLength != null"
        type="warning"
        id="alert-no-appointments"
        :closeable="false"
        :show-icon="false"
      >
        {{ $label("event.no_appointment_exist", "No appointments exist.") }}
      </alert-box>

      <alert-box
        v-show="failedRequest"
        type="warning"
        :closeable="false"
        :show-icon="false"
      >
        {{
          $label(
            "event.event_failed_request",
            "Request failed while loading event appointments."
          )
        }}
      </alert-box>

      <div
        v-show="
          eventAppointmentsLength > 0 &&
            eventAppointmentsLength != null &&
            !failedRequest &&
            !loading
        "
        class="row"
      >
        <div class="col-xs-12">
          <div class="popup-wrapper">
            <div class="table-responsive">
              <fieldset>
                <table
                  class="table dataTable table-striped table-bordered table-hover mb-1"
                  id="table-staff"
                >
                  <thead>
                    <tr>
                      <th class="text-center">
                        {{ $label("common.date", "Date") }}
                      </th>
                      <th class="text-center">
                        {{ $label("common.time", "Time") }}
                      </th>
                      <th class="text-center">
                        {{ $label("common.venue", "Venue") }}
                      </th>
                      <th class="text-center table-settings-staff-action">
                        {{ $label("common.actions", "Actions") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="appointment in eventAppointments"
                      v-bind:key="appointment.id"
                    >
                      <td
                        class="v-align-center text-center"
                        :id="'appointment-date-' + appointment.id"
                      >
                        {{
                          $moment(appointment.starts_at).format("MM/DD/YYYY")
                        }}
                      </td>
                      <td
                        class="v-align-center text-center"
                        :id="'appointment-time-' + appointment.id"
                      >
                        {{ $moment(appointment.starts_at).format("hh:mm") }} -
                        {{ $moment(appointment.ends_at).format("hh:mm") }}
                      </td>
                      <td
                        class="v-align-center text-center"
                        :id="'appointment-venue-' + appointment.id"
                      >
                        {{ appointment.venue.name }}
                      </td>
                      <td class="text-center min-width-auto">
                        <div class="btn-group">
                          <router-link
                            :to="{
                              name: 'EventAppointmentDetails',
                              params: {
                                event_id: selectedEventId,
                                appointment_id: appointment.id
                              }
                            }"
                            data-id="$id"
                            class="btn btn-sm btn-default"
                            ><i class="text-primary fa fa-fw fa-eye"></i>
                            {{ $label("common.details", "Details") }}
                          </router-link>
                          <a
                            @click="deleteEventAppointment(appointment.id)"
                            :id="'delete-appointment-button-' + appointment.id"
                            class="btn btn-sm btn-danger"
                            ><i class="fa fa-fw fa-trash"></i>
                            {{ $label("common.delete", "Delete") }}</a
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="
          eventAppointmentsLength > 0 &&
            eventAppointmentsLength != null &&
            !failedRequest
        "
        class="row"
      >
        <div class="col-sm-6 col-xs-12 dataTables_info">
          {{ from }} - {{ to }} {{ $label("common.pagination_of", "of") }}
          {{ total }}
        </div>
        <div class="col-sm-6 col-xs-12">
          <div
            class="dataTables_paginate paging_bootstrap_full_number"
            style="text-align: right;"
          >
            <ul class="pagination" style="visibility: visible;">
              <li class="prev" :class="{ disabled: disabledFirstPage }">
                <a
                  @click="goToFirstPage"
                  v-tooltip="{
                    content: $label('common.first_page', 'First page'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-double-left"></i
                ></a>
              </li>
              <li class="prev" :class="{ disabled: disabledPreviousPage }">
                <a
                  @click="goToPreviousPage"
                  v-tooltip="{
                    content: $label('common.back'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-left"></i
                ></a>
              </li>
              <li class="active">
                <a>{{ currentPage }}</a>
              </li>
              <li class="next" :class="{ disabled: disabledNextPage }">
                <a
                  @click="goToNextPage"
                  v-tooltip="{
                    content: $label('common.next', 'Next'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-right"></i
                ></a>
              </li>
              <li class="next" :class="{ disabled: disabledLastPage }">
                <a
                  @click="goToLastPage"
                  v-tooltip="{
                    content: $label('common.last_page', 'Last page'),
                    classes: 'custom-tooltip'
                  }"
                  ><i class="fa fa-angle-double-right"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <div class="row mb-8">
        <div class="col-xs-12">&nbsp;</div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api.js";
import swal from "sweetalert";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox";
import Error404 from "@/components/Common/Error404";

export default {
  name: "EventAppointments.vue",

  components: {
    ViewLoader,
    NavigationTabs,
    AlertBox,
    Error404
  },

  data() {
    return {
      eventAppointments: [],
      loading: false,
      updating: false,
      noDataExist: false,
      eventAppointmentsLength: null,
      searchFilter: "",
      failedRequest: false,
      currentPage: 1,
      total: 0,
      from: 0,
      to: 0,
      firstPage: 1,
      lastPage: null,
      perPage: null,
      selectedEvent: null,
      selectedEventId: null,
      componentKey: 0
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedEventId = vm.$route.params.event_id;

      if (
        vm.$route.query.event_appointment_deleted === true ||
        vm.$route.query.event_appointment_deleted === "true"
      ) {
        swal("Success!", "The appointment was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getEventAppointments(() => {
        //
      });
      vm.getEvent(() => {
        //
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.event_appointment_deleted === true) {
      swal("Success!", "The appointment was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (this.to % this.perPage === 1 && this.currentPage !== 1) {
      this.currentPage -= 1;
    }
    this.getEventAppointments(() => {
      //
    });
    this.getEvent(() => {
      //
    });
    next();
  },

  mounted() {
    //
  },

  methods: {
    getEvent() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint("events/" + this.selectedEventId);

      Api()
        .get(endpoint)
        .then(response => {
          this.selectedEvent = response.data.data;
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getEventAppointments(successCallback) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.eventAppointments = [];
      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/appointments"
      );

      Api()
        .get(endpoint, {
          params: {
            page: this.currentPage,
            search: this.searchFilter
          }
        })
        .then(response => {
          this.eventAppointments = response.data.data;
          this.currentPage = response.data.meta.current_page;
          this.total = response.data.meta.total;
          if (response.data.meta.from != null) {
            this.from = response.data.meta.from;
          } else {
            this.from = 0;
          }
          if (response.data.meta.to != null) {
            this.to = response.data.meta.to;
          } else {
            this.to = 0;
          }
          this.lastPage = response.data.meta.last_page;
          this.perPage = response.data.meta.per_page;
          this.eventAppointmentsLength = response.data.data.length;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteEventAppointment(appointmentId) {
      if (this.loading || this.updating || appointmentId == null) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The appointment will be deleted and will not be able to use it",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint(
            "events/" + this.selectedEventId + "/appointments/" + appointmentId
          );

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router
                .push({
                  name: "EventAppointments",
                  query: { event_appointment_deleted: true }
                })
                .catch(error => {
                  console.log(error);
                  if (
                    error.name === "NavigationDuplicated" ||
                    error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    swal("Success!", "The appointment was deleted.", "success");
                    this.getEventAppointments(() => {
                      //
                    });
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete event appointments.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    goToFirstPage() {
      if (!this.disabledFirstPage) {
        this.currentPage = 1;
        this.getEventAppointments(() => {
          //
        });
      }
    },

    goToPreviousPage() {
      if (!this.disabledPreviousPage) {
        this.currentPage--;
        this.getEventAppointments(() => {
          //
        });
      }
    },

    goToNextPage() {
      if (!this.disabledNextPage) {
        this.currentPage++;
        this.getEventAppointments(() => {
          //
        });
      }
    },

    goToLastPage() {
      if (!this.disabledLastPage) {
        this.currentPage = this.lastPage;
        this.getEventAppointments(() => {
          //
        });
      }
    },

    forceRerender() {
      this.componentKey += 1;
    }
  },

  computed: {
    disabledFirstPage() {
      return this.currentPage === 1;
    },

    disabledPreviousPage() {
      return this.currentPage === 1;
    },

    disabledNextPage() {
      return this.currentPage === this.lastPage;
    },

    disabledLastPage() {
      return this.currentPage === this.lastPage;
    }
  },
  watch: {
    perPage() {
      this.getEventAppointments(() => {
        //
      });
    },
    searchFilter() {
      this.getEventAppointment(() => {
        //
      });
    }
  }
};
</script>

<style scoped>
.mt-0 {
  margin-top: 0;
}

.mt-8 {
  margin-top: 1.3rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-1 {
  margin-bottom: 0.3rem;
}

.mb-2 {
  margin-bottom: 0.6rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}

.min-width-auto {
  width: 50px;
}

.pagination-select {
  font-weight: 700;
  height: 34px;
  padding-left: 10px;
  width: 70px;
  cursor: pointer;
  border: 1px solid #ddd;
  color: #666;
  outline: none;
}
</style>
